/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type portfolio_UpdatePortfolioSettingsRequest = {
    default_scale_keys?: Array<string>;
    default_template_key?: string;
    development_talk_cadence: portfolio_UpdatePortfolioSettingsRequest.development_talk_cadence;
    prompted_domain_keys?: Array<string>;
    require_domain_on_document: boolean;
    retention_months_after_exit: number;
};
export namespace portfolio_UpdatePortfolioSettingsRequest {
    export enum development_talk_cadence {
        ANNUAL = 'annual',
        SEMI_ANNUAL = 'semi_annual',
    }
}

